<!-- Bar above table: Total + Showing (left) | Page size dropdown (right) - same as Daily Roster -->
<div class="shrink-0 flex flex-wrap items-center justify-between gap-2 w-full bg-slate-100 border-b border-slate-200 px-3 py-1.5">
  <div class="flex items-center gap-3 text-sm text-slate-700">
    <span class="whitespace-nowrap">Total: <span class="text-primary font-bold">{{ totalItems }}</span></span>
    <span class="whitespace-nowrap" *ngIf="showShowingLine">Showing: <span class="font-semibold text-primary">{{ showingCount }}</span> of {{ showingDenominator }}</span>
  </div>
  <div class="flex items-center gap-2">
    <span class="text-sm text-slate-700 whitespace-nowrap">Page size</span>
    <app-dropdown
      [options]="pageSizeDropdownOptions"
      [value]="displayPageSize"
      [placeholder]="'Select'"
      [id]="'page-size-select'"
      [name]="'pageSize'"
      (valueChange)="onPageSizeChange($event)"
      class="w-28 min-w-[6.5rem]"
    ></app-dropdown>
  </div>
</div>
